import React from "react";
import "./Footer.css";

function Footer() {
    return (
        <footer className="footer">
            Copyright © 2022 Muhammad Ayaan Afzal. All rights reserved.
        </footer>
    );
}

export default Footer;
